import script from "./SortFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./SortFilter.vue?vue&type=script&setup=true&lang=js"

import "./SortFilter.vue?vue&type=style&index=0&id=0fb44ede&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fb44ede"]])

export default __exports__